import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import dayjs from 'dayjs';
export default class EventCard extends Component {
  view() {
    const {
      event,
      pick,
      onMakePick,
      isLoading
    } = this.attrs;
    if (!event || typeof event.id !== 'function') {
      return null;
    }
    const homeTeam = event.homeTeam();
    const awayTeam = event.awayTeam();
    const canPick = event.canPick();
    const status = event.status();
    const result = event.result();
    const homeScore = event.homeScore();
    const awayScore = event.awayScore();
    const reverse = app.forum.attribute('pickem.reverseDisplay');
    let matchDate = '-';
    let cutoffDate = '-';
    try {
      matchDate = dayjs(event.matchDate()).format('DD MMM YYYY, HH:mm');
    } catch {
      matchDate = String(event.matchDate());
    }
    try {
      cutoffDate = dayjs(event.cutoffDate()).format('DD MMM YYYY, HH:mm');
    } catch {
      cutoffDate = String(event.cutoffDate());
    }
    const cutoffDateVal = event.cutoffDate();
    const countdown = cutoffDateVal ? this.getCountdown(cutoffDateVal) : null;
    const firstTeam = reverse ? awayTeam : homeTeam;
    const secondTeam = reverse ? homeTeam : awayTeam;
    const firstTeamLabel = reverse ? app.translator.trans('huseyinfiliz-pickem.lib.common.away') : app.translator.trans('huseyinfiliz-pickem.lib.common.home');
    const secondTeamLabel = reverse ? app.translator.trans('huseyinfiliz-pickem.lib.common.home') : app.translator.trans('huseyinfiliz-pickem.lib.common.away');
    const firstScore = reverse ? awayScore : homeScore;
    const secondScore = reverse ? homeScore : awayScore;
    const firstOutcome = reverse ? 'away' : 'home';
    const secondOutcome = reverse ? 'home' : 'away';
    return m("div", {
      className: "EventCard"
    }, m("div", {
      className: `EventCard-status ${status}`
    }, app.translator.trans(`huseyinfiliz-pickem.lib.status.${status}`)), m("div", {
      className: "EventCard-teams"
    }, m("div", {
      className: "team-container"
    }, this.renderTeamLogo(firstTeam), m("div", {
      className: "team-name"
    }, firstTeam ? firstTeam.name() : firstTeamLabel)), m("div", {
      className: "vs"
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.vs')), m("div", {
      className: "team-container"
    }, this.renderTeamLogo(secondTeam), m("div", {
      className: "team-name"
    }, secondTeam ? secondTeam.name() : secondTeamLabel))), status === 'finished' && homeScore !== null && awayScore !== null && m("div", {
      className: "EventCard-score"
    }, m("div", {
      className: "score-number"
    }, firstScore), m("div", {
      className: "score-separator"
    }, "-"), m("div", {
      className: "score-number"
    }, secondScore)), m("div", {
      className: "EventCard-info"
    }, m("div", null, m("i", {
      className: "fas fa-calendar"
    }), m("strong", null, app.translator.trans('huseyinfiliz-pickem.lib.headers.match_date'), ":"), " ", matchDate), m("div", null, m("i", {
      className: "fas fa-clock"
    }), m("strong", null, app.translator.trans('huseyinfiliz-pickem.lib.headers.cutoff_date'), ":"), " ", cutoffDate), countdown && canPick && m("div", null, m("span", {
      className: `EventCard-countdown ${countdown.urgent ? 'urgent' : ''}`
    }, m("i", {
      className: "fas fa-hourglass-half"
    }), countdown.text)), result && m("div", null, m("i", {
      className: "fas fa-flag-checkered"
    }), m("strong", null, app.translator.trans('huseyinfiliz-pickem.lib.common.result'), ":"), " ", this.formatResult(result, homeTeam, awayTeam))), app.session.user && canPick && m("div", {
      className: "EventCard-picks"
    }, m(Button, {
      className: `Button ${pick && pick.selectedOutcome() === firstOutcome ? 'Button--pickem-selected' : ''}`,
      onclick: () => onMakePick(Number(event.id()), firstOutcome),
      loading: isLoading,
      disabled: isLoading
    }, firstTeam ? firstTeam.name() : firstTeamLabel), event.allowDraw() && m(Button, {
      className: `Button ${pick && pick.selectedOutcome() === 'draw' ? 'Button--pickem-selected' : ''}`,
      onclick: () => onMakePick(Number(event.id()), 'draw'),
      loading: isLoading,
      disabled: isLoading
    }, app.translator.trans('huseyinfiliz-pickem.lib.common.draw')), m(Button, {
      className: `Button ${pick && pick.selectedOutcome() === secondOutcome ? 'Button--pickem-selected' : ''}`,
      onclick: () => onMakePick(Number(event.id()), secondOutcome),
      loading: isLoading,
      disabled: isLoading
    }, secondTeam ? secondTeam.name() : secondTeamLabel)), pick && !canPick && m("div", {
      className: "EventCard-pick-result"
    }, app.translator.trans('huseyinfiliz-pickem.forum.picks.your_pick'), ":", ' ', m("strong", null, this.formatResult(pick.selectedOutcome(), homeTeam, awayTeam)), pick.isCorrect() !== null && m("span", {
      className: pick.isCorrect() ? 'correct' : 'incorrect'
    }, pick.isCorrect() ? ` ✓ ${app.translator.trans('huseyinfiliz-pickem.lib.status.correct')}` : ` ✗ ${app.translator.trans('huseyinfiliz-pickem.lib.status.incorrect')}`)));
  }
  renderTeamLogo(team) {
    if (!team) {
      return m("div", {
        className: "team-logo"
      }, m("span", null, "?"));
    }
    const logoUrl = team.logoUrl();
    const teamName = team.name() || app.translator.trans('core.lib.username.deleted_text');
    if (logoUrl) {
      return m("div", {
        className: "team-logo"
      }, m("img", {
        src: logoUrl,
        alt: String(teamName)
      }));
    }
    const nameStr = String(teamName);
    const initial = nameStr.charAt(0).toUpperCase();
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6', '#1abc9c', '#e67e22', '#34495e'];
    const colorIndex = nameStr.charCodeAt(0) % colors.length;
    const bgColor = colors[colorIndex];
    return m("div", {
      className: "team-logo",
      style: `background-color: ${bgColor};`
    }, m("span", null, initial));
  }
  getCountdown(cutoffDate) {
    try {
      const now = dayjs();
      const cutoff = dayjs(cutoffDate);
      const diff = cutoff.diff(now);
      if (diff <= 0) return null;
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      if (hours < 1) {
        return {
          text: app.translator.trans('huseyinfiliz-pickem.lib.time.minutes_remaining', {
            minutes
          }),
          urgent: minutes < 30
        };
      }
      if (hours < 24) {
        return {
          text: app.translator.trans('huseyinfiliz-pickem.lib.time.hours_remaining', {
            hours,
            minutes
          }),
          urgent: hours < 2
        };
      }
      const days = Math.floor(hours / 24);
      return {
        text: app.translator.trans('huseyinfiliz-pickem.lib.time.days_remaining', {
          days
        }),
        urgent: false
      };
    } catch {
      return null;
    }
  }
  formatResult(result, homeTeam, awayTeam) {
    if (result === 'home') return homeTeam ? homeTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.home');
    if (result === 'away') return awayTeam ? awayTeam.name() : app.translator.trans('huseyinfiliz-pickem.lib.common.away');
    if (result === 'draw') return app.translator.trans('huseyinfiliz-pickem.lib.common.draw');
    return result;
  }
}
flarum.reg.add('huseyinfiliz-pickem', 'forum/components/EventCard', EventCard);